
import {APPLY_JOB_LIST2_REQUEST, APPLY_JOB_LIST2_SUCCESS,APPLY_JOB_LIST2_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const ApplyJobListAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: APPLY_JOB_LIST2_REQUEST,
        payload: true,
      });
   
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_candidate_list_by_applied_job?jobId=${id}&pageNumber=0&pageSize=10`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          // token: token,
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: APPLY_JOB_LIST2_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: APPLY_JOB_LIST2_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };